<template>
    <FilterListBlock
        :name="filter.filter_name"
        :search-input-id="searchInputIdFrom"
        class="filter-list filter-list--range"
    >
        <form class="filter-range" @submit.prevent="setRange">
            <div class="filter-range__inputs">
                <input
                    :id="searchInputIdFrom"
                    v-model.trim="fromField"
                    inputmode="decimal"
                    type="text"
                    name="from"
                    :placeholder="i18n('from price')"
                    :aria-label="`Wyszukiwanie w filtrze ${i18n(
                        'from price'
                    )} – pole edycji`"
                    class="input-custom--small browser-reset"
                    @input="onInput"
                    @blur="onBlur"
                />
                <input
                    :id="searchInputIdTo"
                    v-model.trim="toField"
                    type="text"
                    name="to"
                    inputmode="decimal"
                    :placeholder="i18n('to price')"
                    :aria-label="`Wyszukiwanie w filtrze ${i18n(
                        'to price'
                    )} – pole edycji`"
                    class="input-custom--small browser-reset"
                    @input="onInput"
                    @blur="onBlur"
                />
            </div>
            <button class="filter-range__btn">
                <span>{{ i18n('Update price') }}</span>
                <ReloadIcon width="18" height="18" />
            </button>
        </form>
    </FilterListBlock>
</template>
<script>
import { mapGetters } from 'vuex'
import ReloadIcon from '@icons/reload.svg'
import FilterListBlock from '../FilterListBlock'
import FilterListTypeBase from './FilterListTypeBase.vue'

export default {
    components: {
        FilterListBlock,
        ReloadIcon
    },
    extends: FilterListTypeBase,
    data() {
        return {
            from: null,
            to: null,
            searchInputIdFrom: 'filter-search_' + this.name + '_from',
            searchInputIdTo: 'filter-search_' + this.name + '_to'
        }
    },
    computed: {
        ...mapGetters(['i18n']),
        fromField: {
            get() {
                return this.getField(this.from)
            },
            set(newValue) {
                this.from = this.setField(newValue)
            }
        },
        toField: {
            get() {
                return this.getField(this.to)
            },
            set(newValue) {
                this.to = this.setField(newValue)
            }
        },
        active() {
            return this.filter.active
        }
    },
    watch: {
        active(value) {
            this.parseRange(value)
        }
    },
    created() {
        this.parseRange(this.active)
    },
    methods: {
        /**
         * get active filter value (eg. 0-22) and parse to separate values
         */
        parseRange(value) {
            if (!value) {
                this.from = null
                this.to = null
            } else {
                const [from, to] = value.split('-')

                if (Number(from)) {
                    this.from = this.getField(from)
                }

                if (Number(to)) {
                    this.to = this.getField(to)
                }
            }
        },
        setRange(event) {
            if (!this.from && !this.to) {
                this.toggleFilter(false, this.filter.key)
            }

            if (this.from || this.to) {
                this.toggleFilter(
                    true,
                    this.filter.key,
                    `${this.setField(this.from) || 0}-${
                        this.setField(this.to) || -1
                    }`,
                    `${this.setField(this.from) || 0}-${
                        this.setField(this.to) || -1
                    }`
                )
            } else {
                this.removeFilter(
                    this.filter.key,
                    this.active,
                    this.mediaQueries.mobile
                )
            }

            if (event.submitter && event.submitter.blur) {
                event.submitter.blur()
            }
        },
        onInput(event) {
            this.sanitizeInput(event)
        },
        onBlur() {
            if (this.mediaQueries.mobile) {
                this.setRange()
            }
        },
        /**
         * replace input string to number and delimiters (,.) only
         */
        sanitizeInput(ev) {
            ev.target.value = ev.target.value.replace(/[^(\d+).,(\d+)]/g, '')
        },
        /**
         * get current string from input and replace it to correct float number
         */
        setField(value) {
            let newValue = parseFloat(String(value).replace(',', '.'))
            if (String(newValue).split('.')?.[1]?.length > 2) {
                newValue = newValue.toFixed(2)
            }
            return newValue
        },
        /**
         * parse float number with comma as delimeter
         */
        getField(value) {
            return value ? String(value).replace('.', ',') : null
        }
    }
}
</script>
<style lang="scss">
.filter-range {
    input {
        font-size: 14px;
        height: 56px;
        padding: 16px;
        border: none;
    }

    input + input {
        margin-left: 1.6rem;
    }

    svg {
        fill: currentColor;
    }

    &__inputs {
        display: flex;
    }

    &__btn {
        margin-top: 1.5rem;
        padding: 0 2rem;
        width: 100%;
        background-color: white;

        &:hover {
            svg {
                path {
                    fill: #ffffff;
                }
            }
        }

        span {
            margin: 0 10px;
        }

        @media #{$media-to-sm} {
            display: none;
        }
    }
}
</style>
